import { useEffect } from 'react';

// Troca o manifesto do PWA em runtime, restaurando o anterior ao desmontar (mesmo padrao da tela
// do Pix do balcao, ExibicaoPix.tsx). O site tem DOIS "apps" no mesmo dominio: o CATALOGO
// (manifesto global /manifest.json, start_url /catalogo — pro cliente) e o SISTEMA
// (/manifest-sistema.json, start_url / — pra equipe). Login e Layout "assumem" o manifesto do
// sistema, entao "Instalar app" de dentro do sistema instala um icone que abre o LOGIN do sistema,
// nunca a vitrine. O cliente que so ve /catalogo nunca monta Login/Layout, entao mantem o catalogo.
export const MANIFESTO_SISTEMA = '/manifest-sistema.json';

export function useManifesto(href: string): void {
  useEffect(() => {
    const link = document.querySelector<HTMLLinkElement>('link[rel="manifest"]');
    if (!link) return;
    const anterior = link.getAttribute('href');
    link.setAttribute('href', href);
    return () => { if (anterior) link.setAttribute('href', anterior); };
  }, [href]);
}
